import secondaryComponents from "../../../../../components/secondaryComponents";
import { StorefrontDetailsForm } from "../../../../../components/secondaryComponents/storefront/StorefrontDetailsForm";

const CreateStorfront = () => {
  return (
    <secondaryComponents.MetaSetter
      title={"Lumi Merchant | Inventory - Create Storefront"}
      description={"Create a Storefront"}
    >
      <StorefrontDetailsForm />
    </secondaryComponents.MetaSetter>
  );
};
export default CreateStorfront;
